'use client';

import React from 'react';
import { Icon } from '../Icon';
import { Container, Message, DismissButton, ActionButton } from './elements';
export const Toast = /*#__PURE__*/React.forwardRef(({
  isOpen = false,
  message,
  actionButtonText = '',
  onCloseClick,
  onActionButtonClick,
  buttonAriaLabel = '',
  containerClassName = '',
  messageClassName,
  buttonClassName,
  toastType = 'default',
  iconSrc,
  offset = 2.5
}, fRef) => {
  if (toastType === 'success') {
    iconSrc = 'system-alert-checkmark';
  } else if (toastType === 'error') {
    iconSrc = 'system-alert-alert';
  }
  return /*#__PURE__*/React.createElement(Container, {
    "data-aui": "toast",
    className: containerClassName,
    ref: fRef,
    $type: toastType,
    $offset: offset,
    $isOpen: isOpen
  }, iconSrc && /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    fill: "currentColor",
    size: "normal"
  }), /*#__PURE__*/React.createElement(Message, {
    className: messageClassName
  }, message), actionButtonText && /*#__PURE__*/React.createElement(ActionButton, {
    variant: "flat",
    className: buttonClassName,
    onClick: onActionButtonClick,
    "aria-label": buttonAriaLabel || actionButtonText || 'toast action'
  }, actionButtonText), /*#__PURE__*/React.createElement(DismissButton, {
    "aria-label": "Dismiss alert banner",
    variant: "flat",
    size: "md",
    onClick: onCloseClick
  }, /*#__PURE__*/React.createElement(Icon.SSR, {
    src: "close-x"
  })));
});